export const CONTACTS_LISTS_ACCESS = 'contacts-lists-access';
export const REPORTING_DATASETS_READ = 'reporting-datasets-read';
export const MARKETABLE_CONTACTS_ACCESS = 'marketable-contacts-access';
export const BEHAVIORAL_EVENTS_READ = 'behavioral-events-read';
export const BEHAVIORAL_EVENTS_WRITE = 'behavioral-events-write';
export const CUSTOM_EVENTS_VIEW = 'custom-events-view';
export const WEB_ANALYTICS_API_ACCESS = 'web-analytics-api-access';
export const SALES_DOCUMENTS_READ_ACCESS = 'documents-read-access';
export const WEBHOOK_TRIGGERS_ACCESS = 'workflows-webhook-triggers-access';
export const SCHEDULED_ENROLLMENT_ACCESS = 'automation-scheduled-enrollment-access';
export const SUPER_ADMIN = 'super-admin';